import React from "react";
import { Box, Grid2 } from "@mui/material";
import TeamCard from "../../components/TeamCard";
import teamLogo from "../../assets/images/teamDefault.png"; // Fallback logo
import { useNavigate } from "react-router-dom";
import NoDataView from "../../components/NoDataView";

const AuctionTeams = ({ data, search }) => {
  const auctionTeams = data?.auctionDetails?.auctionTeams || [];
  const teams1 = data?.teams || [];
  const players = data?.teamMembers || [];

  const navigate = useNavigate();

  // 🧠 Count players purchased by each team
  const playersByTeam = players.reduce((acc, player) => {
    if (player.isSold && player.teamId) {
      acc[player.teamId] = (acc[player.teamId] || 0) + 1;
    }
    return acc;
  }, {});

  // 🔗 Merge auction + team info + player count
  const mergedTeams = auctionTeams.map((auctionTeam, index) => {
    const matchedTeam = teams1.find((t) => t._id === auctionTeam.teamId);
    const playersPurchased = playersByTeam[auctionTeam.teamId] || 0;

    return {
      ...matchedTeam,
      ...auctionTeam,
      teamName: matchedTeam?.teamName || "Unknown Team",
      logo: matchedTeam?.teamLogo || teamLogo,
      playersPurchased,
      serialNo:
        matchedTeam?.serialNo ??
        auctionTeam?.serialNo ??
        matchedTeam?.srNo ??
        auctionTeam?.srNo ??
        matchedTeam?.sNo ??
        auctionTeam?.sNo ??
        matchedTeam?.serialNumber ??
        auctionTeam?.serialNumber ??
        matchedTeam?.teamNo ??
        (index + 1),
    };
  });

  // 🛡 Ensure search is always a string
  const safeSearch = String(search || "").trim().toLowerCase();

  // 🔍 Filter teams based on search (team name or serialNo)
  const filteredTeams = mergedTeams.filter((team, index) => {
    if (!safeSearch) return true;

    const nameMatch = team?.teamName?.toLowerCase().includes(safeSearch);

    const isNumeric = !isNaN(safeSearch) && !isNaN(parseFloat(safeSearch));

    const teamSerial =
      team?.serialNo ??
      team?.srNo ??
      team?.serialNumber ??
      team?.teamNo ??
      index + 1;

    const serialMatch = isNumeric
      ? Number(teamSerial) === Number(safeSearch)
      : String(teamSerial).toLowerCase() === safeSearch;

    return nameMatch || serialMatch;
  });

  return (
    <Box
      sx={{
        p: 4,
        paddingX: "3rem",
        backgroundColor: "#fff",
        minHeight: "100vh",
      }}
    >
      <Grid2 container spacing={5} justifyContent="left">
        {filteredTeams.length > 0 ? (
          filteredTeams.map((team, index) => (
            <Grid2
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              xl={2.4}
              columns={4}
            >
              <TeamCard
                teamName={team?.teamName}
                logo={team?.logo}
                totalPoints={team?.totalPoints}
                remainingPoints={team?.currentPoints}
                playersPurchased={team?.playersPurchased}
                totalSlots={data?.teamPlayerCount}
                onView={() =>
                  navigate(`/auction/team/${team?.teamId}/players`, {
                    state: {
                      teamId: team?.teamId,
                      teamName: team?.teamName,
                      tournamentData: data, // send full data here
                    },
                  })
                }
              />
            </Grid2>
          ))
        ) : (
          <NoDataView text="No team found" />
        )}
      </Grid2>
    </Box>
  );
};

export default AuctionTeams;
